import { accountTypes, customerTypes } from '../../flows/shared/utils';
import { isEmptyObject } from '../../core/util';
import { retirementTypeHeaderDisplay } from '../ProfileScreen/util';

export const getHeaderText = (accountType, iraAccountType = null) => {
  if (accountType === accountTypes.INDIVIDUAL) {
    return 'My Account Portfolio';
  }

  const accountHeaderText = `My ${{
    [accountTypes.TRANSFER]: 'Transfer Account',
    [accountTypes.ROLLOVER]: 'Rollover Account',
    [accountTypes.TRUST]: 'Trust Account',
    [accountTypes.JOINT]: 'Joint Account',
    [accountTypes.UGMAUTMA]: 'Minor Account',
    [accountTypes.CONTRIBUTORY]: retirementTypeHeaderDisplay[iraAccountType],
    [accountTypes.ROTH]: 'Roth IRA'
  }[accountType] || 'Transfer Account'} Portfolio`;
  return accountHeaderText;
};

export const showAdditionalCustomers = (additionalCustomers, accountType) =>
  [accountTypes.UGMAUTMA, accountTypes.JOINT].includes(accountType) &&
  additionalCustomers &&
  additionalCustomers.length > 0;

export const showBenes = benes => !isEmptyObject(benes);

export const hasMinorInformation = additionalCustomers =>
  additionalCustomers &&
  additionalCustomers.some(
    customer => customer.customerType === customerTypes.MINOR
  );
